import http from 'src/utils/http'

const URL = 'categories'
const categoryApi = {
  getCategories() {
    return http.get(URL)
  }
}

export default categoryApi
